import { useEffect, useState } from "react";

export function isApple() {
  const [navigator, setNavigator] = useState<Navigator | null>(null);

  useEffect(() => {
    setNavigator(window.navigator);
  }, []);

  const userAgent = navigator?.userAgent?.toLowerCase() ?? "";

  const appleDevices = {
    isMac: /macintosh|mac os x/i.test(userAgent),
    isiPhone: /iphone/i.test(userAgent),
    isiPad: /ipad/i.test(userAgent),
    isiPod: /ipod/i.test(userAgent),
  };

  const isApple =
    appleDevices.isMac ||
    appleDevices.isiPhone ||
    appleDevices.isiPad ||
    appleDevices.isiPod;

  return isApple;
}
